var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("edg-navbar", [
        _c("div", { staticClass: "col-4 pl-0" }, [
          _c(
            "div",
            { staticClass: "d-flex align-items-center" },
            [
              _c("router-link", {
                staticClass: "navbar-toggler lien-accueil",
                attrs: { to: { name: "Accueil" }, custom: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var navigate = ref.navigate
                      return [
                        _c("span", {
                          staticClass: "ge-logo img-fluid",
                          attrs: { role: "button" },
                          on: { click: navigate },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("router-link", {
                staticClass: "navbar-toggler lien-accueil",
                attrs: { to: { name: "Accueil" }, custom: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var navigate = ref.navigate
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "pl-3 title",
                            attrs: { role: "button" },
                            on: { click: navigate },
                          },
                          [_vm._v(_vm._s(_vm.$t("header.title")))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "navbar-expand col-8 row h-100 justify-content-end align-items-center",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "btn-header-menu d-flex flex-column align-items-center lien-accueil",
                on: {
                  click: function ($event) {
                    _vm.isUserLogged ? _vm.logout() : _vm.login()
                  },
                },
              },
              [
                _c("div", { staticClass: "btn-edemarche" }),
                _vm._v(" "),
                _vm.isUserLogged
                  ? _c("div", [_vm._v(_vm._s(_vm.userConnecteNomPrenom))])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { attrs: { role: "button" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        _vm.isUserLogged
                          ? "header.seDeconnecter"
                          : "header.seConnecter"
                      )
                    )
                  ),
                ]),
              ]
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }